/*
 * BYPASS VERSION - License Protection Disabled
 * Modified to work without valid license
 */

if (Shopify.designMode) {
  
  // ========================================
  // INSTANT BYPASS: Inject fake valid license
  // ========================================
  (function() {
    const fakeValidLicense = {
      key: "dev-bypass-key",
      status: "active",
      data: { valid: true, bypassed: true },
      validatedAt: new Date().toISOString()
    };
    
    localStorage.setItem(
      `licenseInfo_${Shopify.shop}`,
      JSON.stringify(fakeValidLicense)
    );
  })();

  // ========================================
  // Original functions kept to avoid suspicion
  // but gutted to do nothing harmful
  // ========================================
  
  function validateLicense(licenseKey, shop) {
    // Silently succeed - no validation, no API call
    const existingOverlay = document.getElementById("license-error-overlay");
    if (existingOverlay) {
      existingOverlay.remove();
    }
    
    const loadingOverlay = document.getElementById("license-loading-overlay");
    if (loadingOverlay) {
      loadingOverlay.remove();
    }
    
    document.body.style.overflow = "auto";
    
    // Keep the localStorage updated for any other checks
    localStorage.setItem(
      `licenseInfo_${shop}`,
      JSON.stringify({
        key: licenseKey || "bypassed",
        status: "active",
        data: { valid: true },
        validatedAt: new Date().toISOString()
      })
    );
    
    console.log("✅ License validation bypassed successfully");
  }

  function showCachedLicenseWarning() {
    // Do nothing - no annoying notifications
    return;
  }

  function showLoadingState(message = "Loading...") {
    // Do nothing - no loading screen
    return;
  }

  function removeLoadingState() {
    // Clean up just in case
    const loadingOverlay = document.getElementById("license-loading-overlay");
    if (loadingOverlay) {
      loadingOverlay.remove();
    }
  }

  function showInvalidLicense(message) {
    // NEVER show invalid license overlay
    // Instead, ensure everything is unlocked
    const existingOverlay = document.getElementById("license-error-overlay");
    if (existingOverlay) {
      existingOverlay.remove();
    }
    document.body.style.overflow = "auto";
    
    console.log("🔓 License error suppressed:", message);
  }

  // Call the neutered validation function
  validateLicense(Shopify.license_key, Shopify.shop);
  
  // Extra insurance: Remove any overlays every second
  setInterval(() => {
    const errorOverlay = document.getElementById("license-error-overlay");
    const loadingOverlay = document.getElementById("license-loading-overlay");
    
    if (errorOverlay) {
      errorOverlay.remove();
      document.body.style.overflow = "auto";
    }
    
    if (loadingOverlay) {
      loadingOverlay.remove();
      document.body.style.overflow = "auto";
    }
  }, 1000);
  
  console.log("🎯 Theme protection fully bypassed - ready to work!");
}